import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card, SwitchAppButton} from "../../components"

import { Select,TextInput } from "../../ui"

import option from "../../assets/icons/option.svg"
import plusIcon from "../../assets/icons/plus-icon.svg"
import brandLogo from "../../assets/icons/upload-brandlogo.svg"

export const View = () =>{
  
    return(

        <>
            <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Business details"
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <div className="display-flex gap-between mt-5">
        <img src={option} alt="option-icon" />
      <p>You cannot change your business details, contact us if you need to change any details.</p>

      </div>
            
      <div className="card-container-business-details">
      <Card>
        <div className="display-flex justify-content--space-around padding-auto" >
                <div>
                    <p>Registered business address</p>
                    <Select/>
                    <p>Type of business</p>
                    <Select/>
                    <p>Company’s Registration number</p>
                    <TextInput/>
                    <p>Registered business name</p>
                    <TextInput/>
                 </div>

                 <div>
                    <p>Industry</p>
                    <TextInput/>
                    <p>Business email address</p>
                    <TextInput/>
                    <p>Business description</p>
                    <div className="form2">
                    <textarea name="" id="text" ></textarea>
                    </div>
                    
                    
                 </div>

                 <div>
                    <p>Business website</p>
                    <TextInput/>
                    <p>Estimated monthly sale</p>
                    <Select/>
                    <p>Upload your brand logo</p>
                <div className="brand-logo-space ">
                    <div className="brand-logo-contents">
                        <img src={brandLogo} alt="brand-logo" />
                        <img src={plusIcon} alt="plus-icon" />
                        <span>Click to here to upload</span>
                    </div>
                    
                </div>
                    
                 </div>
        </div>
        <div className="account-details-button ">
                <SwitchAppButton
                className="account-details-success-primary "
                kind="success"  onClick={ (): void =>{("")} }            
                >Cancel</SwitchAppButton>
                <SwitchAppButton
                className="account-details-success-primary "
                kind="primary"  onClick={ (): void =>{("")} }            
                >Save </SwitchAppButton>
            </div>
      </Card>
      </div>
     
        </>
    )
}